export const OTHER_PRODUCT_RANGE = [
  {
    category: "Fruits",
    testId: "other-products-fruits",
    items: ["Grapes", "Pomegranate", "Orange", "Mango", "Banana"],
  },
  {
    category: "Vegetables",
    testId: "other-products-vegetables",
    items: [
      "Nashik Red Onion",
      "Green Chilli",
      "Garlic",
      "Potato",
      "Tomato",
      "Lemons",
      "Drumstick",
    ],
  },
  {
    category: "Grains",
    testId: "other-products-grains",
    items: ["Jowar", "Bajra", "Wheat", "Rice", "Maize", "Poha"],
  },
  {
    category: "Pulses",
    testId: "other-products-pulses",
    items: ["Chana", "Tur", "Moong", "Urad", "Masoor", "Soybean"],
  },
  {
    category: "Nuts & Seeds",
    testId: "other-products-nuts-seeds",
    items: ["Raisins", "Peanuts", "Sesame", "Sunflower Seeds"],
  },
  {
    category: "Spices & Powders",
    testId: "other-products-spices-powders",
    items: [
      "Turmeric Powder",
      "Chilli",
      "Coriander",
      "Cumin",
      "Mustard",
      "Ginger",
      "Moringa Powder",
    ],
  },
  {
    category: "Herbs & Leaves",
    testId: "other-products-herbs-leaves",
    items: ["Coriander", "Mint", "Curry Leaves", "Methi", "Moringa"],
  },
  {
    category: "Rose & Natural Products",
    testId: "other-products-rose-natural",
    items: [
      "Fresh Rose Flowers",
      "Rose Essential Oil",
      "Organic Manure",
      "Cow Dung Powder / Logs",
    ],
  },
  {
    category: "Poultry & Dairy",
    testId: "other-products-poultry-dairy",
    items: ["Chicken", "Eggs", "Milk"],
  },
];
